<template>
	<div
		class="rounded p-8 flex flex-col gap-4 w-[42rem] max-w-full border-2 backdrop-blur-xl"
		:class="{
			'border-red-500/60 bg-red-500/50': notification.type === 'error',
			'border-green-500/60 bg-green-500/50': notification.type === 'success',
			'border-yellow-500/60 bg-yellow-500/50':
				notification.type === 'warning',
			'border-blue-500/60 bg-blue-500/50': notification.type === 'info',
		}"
	>
		<AtomTitle
			tag="h2"
			size="md"
			:class="[
				'uppercase',
				{
					'text-red-900': notification.type === 'error',
					'text-green-900': notification.type === 'success',
					'text-yellow-900': notification.type === 'warning',
					'text-blue-900': notification.type === 'info',
				},
			]"
		>
			{{ notification.title }}
		</AtomTitle>
		<p
			class="mb-0"
			:class="{
				'text-red-900': notification.type === 'error',
				'text-green-900': notification.type === 'success',
				'text-yellow-900': notification.type === 'warning',
				'text-blue-900': notification.type === 'info',
			}"
		>
			{{ notification.message }}
		</p>
	</div>
</template>

<script setup lang="ts">
import type { NotificationType } from '#base/core/types/NotificationType';

defineProps<{
	notification: NotificationType;
}>();
</script>
